// Sort by manager-defined displayOrder (rows without one go last).
const byDisplayOrder = (a, b) => {
  const av = a.displayOrder == null ? Number.MAX_SAFE_INTEGER : a.displayOrder;
  const bv = b.displayOrder == null ? Number.MAX_SAFE_INTEGER : b.displayOrder;
  return av - bv;
};

export const buildCreatePayload = ({
  customerInfo,
  bookInfo,
  productionInfo,
  services,
  publishingMethod,
}) => {
  return {
    name: customerInfo.name,
    email: customerInfo.email,
    phoneNumber: customerInfo.contact,
    title: bookInfo.title,
    author: bookInfo.author,
    bookFormatId: productionInfo.bookFormatId,
    numberOfPages: bookInfo.numberOfPages,
    numberOfCopies: productionInfo.printRunSelected
      ? productionInfo.numberOfCopies
      : 0,
    manuscriptStatus: `원고 작성률 ${bookInfo.completionRate}%`,
    color: productionInfo.color,
    publishingMethod,
    additionalNotes: bookInfo.additionalNotes,
    serviceOptions: services
      .filter((s) => s.isSelected)
      .slice()
      .sort(byDisplayOrder)
      .map((s) => ({
        serviceOptionId: s.serviceOptionId,
        quantity: s.qty,
      })),
  };
};

const formatPrice = (price) => {
  return price.toLocaleString("ko-KR", { style: "currency", currency: "KRW" });
};

export const buildQuoteEmailParams = ({
  publisherInfo,
  customerInfo,
  bookInfo,
  productionInfo,
  services,
  quoteSubtotal,
  quoteTax,
  quoteGrandTotal,
  uploadedFileData,
  publishingMethod,
}) => {
  // The 아마존 route has no paper-book production step, so production fields
  // (page count, format, copies, color) don't apply — blank them so they don't
  // appear in the email (the EmailJS template hides empty values).
  const isAmazon = publishingMethod === "amazon";
  const selectedServices = services
    .filter((s) => s.isSelected)
    .slice()
    .sort(byDisplayOrder)
    .reduce((acc, service) => {
      const { category, title, qty, unit, unitPrice } = service;
      const totalPrice = unitPrice * qty;
      const flatTitle = (title || "").replace(/\s*\n\s*/g, " ");
      const serviceLine = `- ${flatTitle}: ${qty}${unit || ""} * ${formatPrice(unitPrice)} = ${formatPrice(totalPrice)}`;

      if (!acc[category]) acc[category] = [];
      acc[category].push(serviceLine);
      return acc;
    }, {});

  const formattedServices = Object.entries(selectedServices)
    .map(([category, lines]) => `[${category}]\n${lines.join("\n")}`)
    .join("\n\n");

    console.log(uploadedFileData);
  const manuscriptFilesString = uploadedFileData
    .map(file => `${file.fileName}: ${file.fileLink}`)
    .join("\n");
  

  return {
    // ...publisherInfo,
    publisherName: publisherInfo.companyName,
    publisherAddress: publisherInfo.address,
    publisherPhone: publisherInfo.phone,
    publisherEmail: publisherInfo.email,

    // ...customerInfo,
    customerName: customerInfo.name,
    customerPhone: customerInfo.contact,
    customerEmail: customerInfo.email,

    title: bookInfo.title,
    author: bookInfo.author,
    completionRate: bookInfo.completionRate,
    numberOfPages: isAmazon ? "" : bookInfo.numberOfPages,
    additionalNotes: bookInfo.additionalNotes,
    numberOfCopies: isAmazon
      ? ""
      : productionInfo.printRunSelected
      ? productionInfo.numberOfCopies
      : 0,
    color: isAmazon ? "" : productionInfo.color,
    bookFormatSize: isAmazon ? "" : productionInfo.bookFormatSize,
    bookFormatDescription: isAmazon ? "" : productionInfo.bookFormatDescription,

    manuscriptFiles: manuscriptFilesString || "-",

    services: formattedServices || "-",

    subtotal: formatPrice(quoteSubtotal),
    tax: formatPrice(quoteTax),
    grandTotal: formatPrice(quoteGrandTotal)
  };
};

